import tableRelatedConfgiThirdParty from './tableRelatedConfgiThirdParty';

export default {
  title: 'Available Provider',
  attributeName: 'availableProviders',
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRelatedConfgiThirdParty
};
